import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
import NewCryptoJs from "@Src/utils/crypto";
import { Env, getDataFromLocalStorage } from "@Src/utils/globalUtilities";
import axios from "axios";
const crypto = new NewCryptoJs();

const unauthorizedCode = [401];
const bypassErrorToComponentCode = ["FAILURE"];
const generateMachineId = () => {
  return Math.random().toString(36).slice(2, 15);
};

export const NodeBookStoreBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_NODE_LEARNING_URL,
});

NodeBookStoreBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem(LocalStorageDataModel.AUTH_TOKEN);
    let machineid = localStorage.getItem(LocalStorageDataModel.MACHINE_ID_NEW);
    let contenttoken = localStorage.getItem(
      LocalStorageDataModel.CONTENT_TOKEN
    );
    let doEncrypt = true;

    if (!window.location.href.includes("www.taxmann.com")) {
      doEncrypt = localStorage.getItem("isDev") ? false : true;
    }
    if (!config.headers.encrypt) {
      doEncrypt = false;
    }
    config.headers = {
      refreshtoken: sessionStorage.getItem("refreshToken") || "",
      machineid: machineid,
      encrypt: doEncrypt,
      // "ngrok-skip-browser-warning": 1,
    };

    if (doEncrypt) {
      config.data = {
        encodedPayload: crypto.encrypt(JSON.stringify(config.data)),
      };
    }

    if (token) {
      config.headers = {
        ...config.headers,
        taxmannauthorization: token,
        contenttoken: contenttoken,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

NodeBookStoreBaseService.interceptors.response.use(
  (response) => {
    if (response?.config?.headers?.encrypt) {
      const data = JSON.parse(crypto.decrypt(response?.data?.data));
      response.data.data = data;
    }
    return response;
  },
  (error) => {
    const { response } = error;
    if (bypassErrorToComponentCode.includes(response?.data?.ResponseType)) {
      return response;
    }
    if (response && unauthorizedCode.includes(response.status)) {
    }
    return Promise.reject(error);
  }
);
